export default __webpack_public_path__ + "static/media/bgFour.ac069a71.jpg";